export default __webpack_public_path__ + "static/media/CNo.50-0.9b733634.jpg";